export default "__VITE_ASSET__CYQMkRX0__"